
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kariyer",
      function () {
        return require("private-next-pages/kariyer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kariyer"])
      });
    }
  